export default "__VITE_ASSET__Rq0xLoCp__"